import './App.css';
  import AppRoutes from "./routes";
  //import SelectYourLocation from './views/auth/SelectYourLocation';
  import Login from './views/auth/login';
  //import  MemberShipPlanPayment from './views/investor/MembershipPlanPaymentUk'
  //import MembershipPlanPayment1 from './views/investor/MembershipPlanPayment1'
function App() {
  return (
         <AppRoutes/>
  );
}

export default App;
